import React from 'react';
import ReactDOM from 'react-dom';
import { PersistGate } from 'reduxjs-toolkit-persist/integration/react';
import { Provider } from 'react-redux';
import { SnackbarProvider } from 'notistack';
import reportWebVitals from './reportWebVitals';
import { Routes } from './routes';
import ThemeProvider from './styles/theme';
import './styles/common.scss';
import 'react-image-crop/dist/ReactCrop.css';
import { store, persistor } from './redux/store';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <SnackbarProvider
          maxSnack={2}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          autoHideDuration={3000}
          dense
          preventDuplicate
        >
          <ThemeProvider>
            <Routes />
          </ThemeProvider>
        </SnackbarProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
